// Bootstrap, its icons and the PT Serif Caption font are bundled rather than linked from CDNs, so a
// slow or blocked CDN (hotel / arena wifi) can't hold up the first paint. Pinned to the versions the
// CDN served; keep these first so the app's own CSS still overrides them
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // data-bs-* behaviour (navbar collapse, dropdowns)
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fontsource/pt-serif-caption/400.css";
import "@fontsource/pt-serif-caption/400-italic.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import PrimeVue from "primevue/config";
import App from "./App.vue";
import { useAuthStore } from "./stores/auth";
import { watchForExpiredSession } from "./utils/session";

// Global component registration
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "./assets/css/styles.css";

const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
watchForExpiredSession(useAuthStore(pinia));
app.use(router);
app.use(PrimeVue);
app.component("DataTable", DataTable);
app.component("ColumnDataTable", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("RowDataTable", Row);
app.component("VueDatePicker", VueDatePicker);
app.mount("#app");

